import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import { EMPTY_REVIEW, reviewPayload } from "@/lib/reviews";
import { ReviewFields } from "./ReviewFields";

export const ReviewForm = () => {
  const [form, setForm] = useState({ ...EMPTY_REVIEW, website: "" });
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const tid = (s) => `story-${s}`;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/reviews", reviewPayload(form));
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50/60 p-8 text-center" data-testid={tid("success")}>
      <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto" />
      <h3 className="mt-4 font-display text-3xl text-navy">Thank you, {form.name.split(" ")[0]}!</h3>
      <p className="mt-2 text-sm text-slate-600">Your story has been sent to our team. Once approved, it will appear on our website.</p>
      <Button variant="outline" className="mt-6 rounded-full h-11" data-testid={tid("new")} onClick={() => { setDone(false); setForm({ ...EMPTY_REVIEW, website: "" }); }}>Share another story</Button>
    </div>
  );

  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid={tid("form")}>
      <ReviewFields form={form} setForm={setForm} tid={tid} onBusy={setBusy} />
      <div className="space-y-1.5 sm:col-span-2">
        <Label htmlFor={tid("phone")}>Phone / WhatsApp (optional, never shown publicly)</Label>
        <Input id={tid("phone")} type="tel" maxLength={20} value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} placeholder="+91 98765 43210" className="h-11" data-testid={tid("phone-input")} />
      </div>
      <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={form.website} onChange={(e) => setForm((f) => ({ ...f, website: e.target.value }))} />
      <p className="sm:col-span-2 text-xs text-slate-500">By submitting, you allow Ocean Wings Travel to show your review, first name and photos on this website.</p>
      <Button type="submit" disabled={loading || busy} data-testid={tid("submit-button")} className="sm:col-span-2 h-12 rounded-full bg-ocean hover:bg-navy text-base font-semibold">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : busy ? "Uploading photos..." : "Submit my story"}
      </Button>
    </form>
  );
};
